import createIntlWithLocale from '../../internal/createIntlWithLocale';
import selectUnit from '../../internal/date-formatter/selectUnit';
import { handleReactIntlError } from '../../internal/errors/handleReactIntlError/handleReactIntlError';
import mergeOptions from '../../internal/mergeOptions';
/**
 * @see https://sail.stripe.me/apis/intl/useIntl/#format-relative-time
 */ export default function formatRelativeTime(/** The intl config object containing the locale data. When using this API through the `useIntl` hook, this config object is automatically injected. */ config, reports, analytics, /** The start date. */ from) {
    const defaults = {
        locale: config.locale
    };
    const mergedOptions = mergeOptions(config, defaults, reports);
    const intl = createIntlWithLocale(mergedOptions.locale, config, reports, analytics);
    const { value, unit } = selectUnit(from, Date.now());
    try {
        return intl.formatRelativeTime(value, unit, {
            numeric: 'auto',
            style: 'long'
        });
    } catch (error) {
        handleReactIntlError(reports, analytics, config.locale, error);
        return '';
    }
}

//# sourceMappingURL=formatRelativeTime.js.map